/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_BriefInputs */

const cs_blog_ai_brief = /** @type {(inputs: Blog_Ai_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadání pro generování`)
};

const en_blog_ai_brief = /** @type {(inputs: Blog_Ai_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief for generation`)
};

/**
* | output |
* | --- |
* | "Brief for generation" |
*
* @param {Blog_Ai_BriefInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_brief = /** @type {((inputs?: Blog_Ai_BriefInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_BriefInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_brief(inputs)
	return cs_blog_ai_brief(inputs)
});